import styled from 'styled-components'

import CheetahIcon, { CheetahIconPack } from '@/components/atomic/atoms/CheetahIcon'
import Text from '@/components/atomic/atoms/Text'

export interface Summary {
  name: string
  description: string
  icon: CheetahIconPack
}

export interface Props {
  title: string
  summaries: Summary[]
}

const TreatmentSummary = ({ title, summaries }: Props): JSX.Element => {
  return (
    <StyledContainer>
      <Text type="title3" element="h2">
        {title}
      </Text>
      <div>
        {summaries.map(
          ({ name, description, icon }, index) =>
            name &&
            description &&
            icon && (
              <StyledSummary key={`${name}_${index}`}>
                <StyledIcon name={icon} width="30" height="30" />
                <Text type="description2" element="h3">
                  {name}
                </Text>
                <Text type="caption1" element="p">
                  {description}
                </Text>
              </StyledSummary>
            ),
        )}
      </div>
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  h2 {
    margin-bottom: 16px;
  }
  h3 {
    margin-bottom: 5px;
  }
`
const StyledSummary = styled.div`
  position: relative;
  margin-left: 40px;
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 0px;
  }
`
const StyledIcon = styled(CheetahIcon)`
  position: absolute;
  left: -40px;
  top: 2px;
`

export default TreatmentSummary
